import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDialogStore = defineStore('dialogs', () => {
    const isMoveEmployeeDialogOpen = ref(false);

    return { isMoveEmployeeDialogOpen };
});
